// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import bemify from 'bemify-js';

import Tag from 'app/common/components/Tag';
import 'app/common/components/OnOffIndicator.scss';

const bem = bemify('on-off-indicator');
const OnOffIndicator = ({ className, isOn }) => (
  <Tag className={bem(className)} kind={{ success: isOn, pill: true }}>
    {isOn ? 'On' : 'Off'}
  </Tag>
);

OnOffIndicator.propTypes = {
  isOn: PropTypes.bool.isRequired,
};

export default OnOffIndicator;
